import Vue from 'vue';
import _ from 'lodash';
import {
  dynamicPHPPath,
} from '@utilities';

export default {
  async addBulbsToPlaylist(context) {
    try {
      context.commit('setSlideout', null);
      context.commit('setIsUpdating', true);
      const { data: responseData } = await Vue.$api.module.addBulbs(context.state.playlistId, context.state.moduleSelected.id, context.state.passbackBulbs);
      context.commit('setPlaylist', responseData.playlist);
      context.commit('setUsedItemsInPlaylist');
      context.commit('toggleSnackbar', {
        text: 'Bulbs added to module.',
        color: 'success',
      });
    } catch(e) {
      context.commit('toggleSnackbar', {
        text: 'Error adding bulbs to module.',
        color: 'error',
      });
      throw e;
    } finally {
      context.commit('resetPassbackBulbs');
      context.commit('setModuleSelected', null);
      context.commit('setIsUpdating', false);
    }
  },
  async addCertifificateMessage(context, message) {
    try {
      context.commit('setIsUpdating', true);
      const messageData = {
        data: message,
        type: 'certificateMessage',
      };
      await Vue.$api.playlist.createCertificateItem(context.state.playlistId, messageData);
      context.commit('setCertificateMessage', message);
      context.commit('toggleSnackbar', {
        text: 'Message saved!',
        color: 'success',
      });
    } catch (e) {
      context.commit('toggleSnackbar', {
        text: 'Error updating message.',
        color: 'error',
      });
      throw e;
    } finally {
      context.commit('setIsUpdating', false);
    }
  },
  async addItemToModule(context, data) {
    try {
      context.commit('setIsUpdating', true);
      const { data: responseData } = await Vue.$api.module.addItem(context.state.playlistId, data);
      context.commit('setPlaylist', responseData.playlist);
    } catch (e) {
      context.commit('toggleSnackbar', {
        text: 'Error adding bulb to module.',
        color: 'error',
      });
      context.commit('setPlaylist', context.state.playlistClone);
      context.commit('incrementPlaylistDesignerKey');
      throw (e);
    } finally {
      context.commit('setIsUpdating', false);
    }
  },
  async addLink(context, link) {
    try {
      context.commit('setIsUpdating', true);
      context.commit('setSlideout', null);
      const { data: responseData } = await Vue.$api.module.addLink(context.state.playlistId, context.state.moduleSelected.id, link);
      context.commit('setPlaylist', responseData.playlist);
    } catch (e) {
      context.commit('toggleSnackbar', {
        text: 'Error adding link.',
        color: 'error',
      });
      throw e;
    } finally {
      context.commit('setModuleSelected', null);
      context.commit('setIsUpdating', false);
    }
  },
  async copyCoursePlaylist(context) {
    try {
      context.commit('setIsUpdating', true);
      const { data: responseData } = await Vue.$api.playlist.copy(context.state.playlistId);
      context.commit('setAlreadyCopied', _.get(responseData, 'alreadyCopied', false));
      context.commit('setCopiedPlaylistHash', responseData.copiedPlaylistId);
    } catch (e) {
      context.commit('toggleSnackbar', {
        text: 'Error copying course.',
        color: 'error',
      });
      throw e;
    } finally {
      context.commit('setIsUpdating', false);
    }
  },
  async createAttachment(context, data) {
    try {
      context.commit('setIsUpdating', true);
      context.commit('setSlideout', null);
      const { data: fileLog } = await Vue.$api.attachment.create({
        name: data.file.name,
        ..._.pick(data.file, ['name', 'size', 'type']),
        teacherId: context.state.user.id,
        schoolId: context.state.user.schoolId,
      });
      const formData = new FormData();
      formData.append('file', data.file);
      await Vue.$api.attachment.upload({
        url: fileLog.temporaryUploadURL,
        file: data.file,
      });
      await Vue.$api.attachment.update({
        id: fileLog.id,
        status: 'ready',
      });
      const { data: responseData } = await Vue.$api.playlist.createAttachment({
        playlistId: context.state.playlistId,
        attachmentId: fileLog.id,
        name: fileLog.name,
        moduleId: data.module.id,
        order: data.module.moduleItems.length,
      });
      context.commit('incrementPlaylistDesignerKey');
      context.commit('setPlaylist', responseData.playlist);
    } catch (e) {
      throw e;
    } finally {
      context.commit('setIsUpdating', false);
      context.commit('setModuleSelected', null);
    }
  },
  async createBadgrBadgeClass(context, badgeData) {
    try {
      context.commit('setIsUpdating', true);
      const badgeClassData = await Vue.$api.badgr.createBadgeClass(
        badgeData.playlistId,
        badgeData.badge,
        badgeData.issuerEntityId,
      );
      return badgeClassData;
    } catch (e) {
      throw e;
    } finally {
      context.commit('setIsUpdating', false);
    }
  },
  async createCertificateItem(context, data) {
    try {
      context.commit('setIsUpdating', true);
      const { data: fileLog } = await Vue.$api.attachment.create({
        name: data.file.name,
        ..._.pick(data.file, ['name', 'size', 'type']),
        teacherId: context.state.user.id,
        schoolId: context.state.user.schoolId,
      });
      const formData = new FormData();
      formData.append('file', data.file);
      await Vue.$api.attachment.upload({
        url: fileLog.temporaryUploadURL,
        file: data.file,
      });
      const fileData = {
        data: fileLog.url,
        type: data.certificateFileType,
      };
      await Vue.$api.playlist.createCertificateItem(context.state.playlistId, fileData);
      const mutation = data.certificateFileType === 'certificateBadge' ? 'setCertificateBadge' : 'setCertificateSignature';
      context.commit(mutation, fileLog.url);
    } catch (e) {
      throw e;
    } finally {
      context.commit('setIsUpdating', false);
    }
  },
  async createModule(context, data) {
    try {
      context.commit('setIsUpdating', true);
      const module = await Vue.$api.module.create(context.state.playlistId, data);
      context.commit('addNewModule', {
        config: module.data.config,
        playlistId: module.data.playlistId,
        default_color: module.data.defaultColor,
        id: module.data.id,
        moduleItems: [],
        name: module.data.name,
        order: module.data.order,
      });
      context.commit('toggleSnackbar', {
        text: 'New module created!',
        color: 'success',
      });
      return module;
    } catch (e) {
      context.commit('toggleSnackbar', {
        text: 'Error creating new module.',
        color: 'error',
      });
      throw (e);
    } finally {
      context.commit('setIsUpdating', false);
    }
  },
  async deleteModule(context, moduleId) {
    try {
      context.commit('setIsUpdating', true);
      const { data: responseData } = await Vue.$api.module.delete(context.state.playlistId, moduleId);
      context.commit('setPlaylist', responseData.playlist);
      if (context.state.showSlideout) {
        context.state.showSlideout = false;
        context.commit('resetPassbackBulbs');
      }
      context.commit('toggleSnackbar', {
        text: 'Module deleted!',
        color: 'success',
      });
      return responseData;
    } catch (e) {
      context.commit('toggleSnackbar', {
        text: 'Error deleting module.',
        color: 'error',
      });
      throw (e);
    } finally {
      context.commit('setIsUpdating', false);
    }
  },
  async decodeUserId(context, encodedId) {
    try {
      return await Vue.$api.playlist.decodeUser(encodedId);
    } catch (e) {
      throw e;
    }
  },
  async encodeUserId(context, userId) {
    try {
      return await Vue.$api.playlist.encodeUser(userId);
    } catch (e) {
      throw e;
    }
  },
  async getInitialBadgrData() {
    try {
      let { data: { issuers, badgrTeacherIdentities } } = await Vue.$api.badgr.issuers(); // eslint-disable-line prefer-const
      issuers = issuers.map((i) => {
        const pickedItems = _.pick(i, ['entityId', 'name', 'image']);
        return { ...pickedItems, ...{ pending: false } };
      });
      if (badgrTeacherIdentities.length) {
        for (const identity of badgrTeacherIdentities) {
          const issuer = _.find(issuers, { entityId: identity.identityType.substring(6) }); // [identity.identityId] = identity.pending;
          if (issuer) {
            if (_.get(identity, 'identityId') === 'pending') issuer.pending = true;
            else if (_.get(identity, 'identityId') === 'approved') {
              issuer.pending = false;
              issuer.approved = true;
            } else issuer.pending = false;
          }
        }
      }
      return {
        issuers,
        badgrTeacherIdentities,
      };
    } catch(e) {
      throw e;
    }
  },
  async getInitialCredlyData(context) {
    try {
      return await Vue.$api.credly.getBadges(context.state.user.schoolId);
    } catch (e) {
      throw e;
    }
  },
  async getOrCreateLMB(context, data) {
    try {
      return await Vue.$api.playlist.getOrCreateLMB({
        bulbId: data.bulbId,
        sectionId: data.sectionId,
      });
    } catch (err) {
      throw (err);
    }
  },
  async getPlaylist(context, data) {
    try {
      const { data: responseData } = await Vue.$api.playlist.get(data);
      context.commit('setHasPlaylistCertificateAccess', _.get(responseData, 'playlist.config.certificateAccess', false));
      context.commit('setPlaylist', responseData.playlist);
      context.commit('updateUser', responseData.user);
      context.commit('setCourseCopy', responseData.courseCopy);
      if (_.get(responseData, 'playlistAttempt', false)) context.commit('setPlaylistAttempt', responseData.playlistAttempt);
      return responseData;
    } catch (e) {
      throw e;
    }
  },
  async getSimplifiedPlaylist(context, data) {
    try {
      const responseData = await Vue.$api.playlist.getSimplified(data);
      context.commit('setHasPlaylistCertificateAccess', _.get(responseData, 'data.playlistData.config.certificateAccess', false));
      return responseData;
    } catch (e) {
      throw e;
    }
  },
  async launchDashAssign(context, playlistId) {
    try {
      Vue.$api.dash.assign(context.state.userToken, playlistId);
    } catch (e) {
      throw (e);
    }
  },
  async launchDashMonitor(context, sectionId) {
    try {
      Vue.$api.dash.monitor(sectionId, context.state.userToken, context.state.playlistId);
    } catch (e) {
      throw (e);
    }
  },
  async markModuleItemAttemptComplete(context, moduleItemId) {
    try {
      const { data: responseData } = await Vue.$api.playlist.markModuleItemAttemptComplete({
        playlistId: context.state.playlistId,
        playlistAttemptId: context.state.playlistAttempt.playlistAttemptId,
        moduleItemId,
        sectionId: context.state.sectionId,
      });
      context.commit('setPlaylist', responseData.playlist);
      if (_.get(responseData, 'playlistAttempt', false)) context.commit('setPlaylistAttempt', responseData.playlistAttempt);
    } catch (e) {
      throw e;
    }
  },
  async removeItem(context, data) {
    try {
      context.commit('setIsUpdating', true);
      const { data: responseData } = await Vue.$api.item.delete(context.state.playlistId, data);
      context.commit('setPlaylist', responseData.playlist);
      context.commit('setUsedItemsInPlaylist');
    } catch (e) {
      context.commit('setPlaylist', context.state.playlistClone);
      throw e;
    } finally {
      context.commit('incrementPlaylistDesignerKey');
      context.commit('setIsUpdating', false);
    }
  },
  async updateItem(context, data) {
    try {
      context.commit('setIsUpdating', true);
      const { data: responseData } = await Vue.$api.item.update(context.state.playlistId, data);
      context.commit('setPlaylist', responseData.playlist);
    } catch (e) {
      throw e;
    } finally {
      context.commit('setIsUpdating', false);
    }
  },
  async updateBulbSettings(context, bulb) {
    try {
      context.commit('setIsUpdating', true);
      const { data: responseData } = await Vue.$api.module.updatePlaylistBulbSettings({
        playlistId: context.state.playlistId,
        bulb,
      });
      context.commit('setPlaylist', responseData.playlist);
    } catch (e) {
      throw e;
    } finally {
      context.commit('setIsUpdating', false);
    }
  },
  async getTags({ commit, state, rootState }, tagSearchString) { // eslint-disable-line
    try {
      const tags = {
        age: [],
        subject: [],
        keywords: [],
        rawData: [],
      };
      const res = await Vue.$api.module.getTags(tagSearchString);
      const age = [];
      const subject = [];
      const proquest = [];
      const standards = [];
      const keywords = [];
      res.data.data.forEach((item) => {
        if (item.type === 'age') age.push(item.value);
        if (item.type === 'subject') subject.push(item.value);
        if (item.type === 'proquest') proquest.push(item.value);
        if (item.type === 'standards') standards.push(item.value);
        if (item.id === 1) {
          item.value.forEach((word) => {
            keywords.push(word.text);
          });
        }
      });
      tags.age = age;
      tags.subject = subject.sort();
      tags.proquest = proquest.sort();
      tags.standards = standards;
      tags.keywords = keywords;
      tags.rawData = res.data.data;
      commit('setTags', tags);
    } catch(e) {
      commit('toggleSnackbar', {
        text: 'Failed to retrieve general tags',
        color: 'error',
      });
      throw e;
    }
  },
  async fetchPlaylistBulbTags({ commit }, bulb) {
    try {
      commit('setIsUpdating', true);
      const { data: tags } = await Vue.$api.module.getModuleBulbTags(bulb.id || bulb.bulb_id); // because tags are the worse...
      Vue.set(bulb, 'tags', tags);
    } catch (e) {
      commit('toggleSnackbar', {
        text: 'Failed to retrieve associated bulb tags',
        color: 'error',
      });
      throw e;
    } finally {
      commit('setIsUpdating', false);
    }
  },
  async removeCertificateItem(context, key) {
    try {
      context.commit('setIsUpdating', true);
      await Vue.$api.playlist.removeCertificateItem(context.state.playlistId, key);
    } catch (e) {
      throw e;
    } finally {
      context.commit('setIsUpdating', false);
    }
  },
  async requestBadgrIssuerAccess(context, issuerProfile) {
    try {
      context.commit('setIsUpdating', true);
      await Vue.$api.badgr.requestIssuer(issuerProfile);
      context.commit('toggleSnackbar', {
        text: 'Badgr request sent!',
        color: 'success',
      });
    } catch (e) {
      context.commit('refreshSettings');
      context.commit('toggleSnackbar', {
        text: 'Error requesting Badgr profile.',
        color: 'error',
      });
      throw (e);
    } finally {
      context.commit('setIsUpdating', false);
    }
  },
  async requestPaywall(context, data) {
    try {
      context.commit('setIsUpdating', true);
      const { data: responseData } = await Vue.$api.playlist.paywall(context.state.playlistId, data);
      context.commit('setPlaylist', responseData.playlist);
      context.commit('toggleSnackbar', {
        text: 'Paywall request sent!',
        color: 'success',
      });
    } catch (e) {
      context.commit('refreshSettings');
      context.commit('toggleSnackbar', {
        text: 'Error requesting paywall.',
        color: 'error',
      });
      throw (e);
    } finally {
      context.commit('setIsUpdating', false);
    }
  },
  async setModuleItem(context, moduleItem) {
    try {
      context.commit('setLastPDFPage', null);
      if (_.get(context.state.playlist, 'config.lockProgression', false)) {
        // If lockedProgression and the playlist is not complete - set the requiredIndex to the index of the active moduleItem
        if (!context.state.isCompleted) {
          const activeItemIndex = _.findIndex(context.state.playlist.allModuleItems, { itemId: moduleItem.itemId });
          context.commit('setRequiredItemIndex', _.max([activeItemIndex, context.state.requiredItemIndex]));
        } else context.commit('setRequiredItemIndex', context.state.playlist.allModuleItems.length - 1);
        // Playlist is complete - unlock all moduleItems by setting requiredIndex to the last item
      }
      const moduleItemAttemptExists = _.find(context.state.allModuleItemAttempts, { moduleItemId: moduleItem.id });
      let playlistAttempt;
      if (!moduleItemAttemptExists && context.state.user.userType === 'student') {
        const { data: responseData } = await Vue.$api.playlist.createModuleItemAttempt({
          playlistAttemptId: context.state.playlistAttempt.playlistAttemptId,
          moduleItem,
        });
        playlistAttempt = responseData;
      }
      if (playlistAttempt) context.commit('setPlaylistAttempt', playlistAttempt);
      context.commit('setActiveModuleItemId', moduleItem.itemId);
    } catch (err) {
      throw (err);
    }
  },
  async syncLTI({ state, commit }) {
    try {
      const syncLTIPayload = {
        consumerKey: (!state?.lti13Launch)
          ? state?.playlist?.lti2CustomResourceLinkInfo?.lti2ResourceLink?.lti2Context?.lti2Consumer?.consumerKey256
          : state?.playlist?.lti13CustomResourceLinkInfo?.lti13ResourceLink?.lti13Context?.lti13Consumer?.clientId,
        resourceLinkId: (!state?.lti13Launch)
          ? state?.playlist?.lti2CustomResourceLinkInfo?.lti2ResourceLink?.ltiResourceLinkId
          : state?.playlist?.lti13CustomResourceLinkInfo?.lti13ResourceLink?.id,
        sectionId: (!state?.lti13Launch)
          ? state?.playlist?.lti2CustomResourceLinkInfo?.sectionId
          : state?.playlist?.lti13CustomResourceLinkInfo?.sectionId,
        lti13Launch: state?.lti13Launch,
        ...(state?.lti13Launch && { issuer: state.lmsIssuer }),
      };
      commit('toggleSnackbar', {
        text: 'Started LTI Grade Sync',
        color: 'success',
      });
      const res = await Vue.$api.playlist.syncLTI(syncLTIPayload);
      if (res?.data?.syncStatus) {
        commit('toggleSnackbar', {
          text: res?.data?.syncStatus?.msg,
          color: res?.data?.syncStatus?.status ? 'success' : 'error',
        });
      }
    } catch (err) {
      const errText = _.get(err, 'msg', 'Error triggering LTI Grade Sync');
      commit('toggleSnackbar', {
        text: errText,
        color: 'error',
      });
    }
  },
  async updatePlaylist(context, data) {
    try {
      context.commit('setIsUpdating', true);
      const { data: responseData } = await Vue.$api.playlist.update(context.state.playlistId, data);
      context.commit('setPlaylist', responseData.playlist);
      context.commit('toggleSnackbar', {
        text: 'Updated course!',
        color: 'success',
      });
    } catch (e) {
      context.commit('refreshSettings');
      context.commit('toggleSnackbar', {
        text: 'Error updating course.',
        color: 'error',
      });
      throw (e);
    } finally {
      context.commit('setIsUpdating', false);
    }
  },
  async updateModule(context, data) {
    try {
      context.commit('setIsUpdating', true);
      const module = await Vue.$api.module.update(context.state.playlistId, data.moduleId, data.module);
      return module;
    } catch (e) {
      context.commit('toggleSnackbar', {
        text: 'Error updating module.',
        color: 'error',
      });
      throw (e);
    } finally {
      context.commit('setIsUpdating', false);
    }
  },
  async updateResourceOrder(context, data) {
    try {
      context.commit('setIsUpdating', true);
      const { data: responseData } = await Vue.$api.attachment.reorder(context.state.playlistId, data);
      context.commit('setPlaylist', responseData.playlist);
      context.commit('toggleSnackbar', {
        text: 'Updated course!',
        color: 'success',
      });
    } catch (e) {
      context.commit('toggleSnackbar', {
        text: 'Error updating course.',
        color: 'error',
      });
      throw (e);
    } finally {
      context.commit('setIsUpdating', false);
    }
  },
  async updateResourceName(context, resource) {
    try {
      context.commit('setIsUpdating', true);
      const { data: responseData } = await Vue.$api.attachment.rename(context.state.playlistId, resource);
      context.commit('setPlaylist', responseData.playlist);
      context.commit('toggleSnackbar', {
        text: 'Updated course!',
        color: 'success',
      });
    } catch (e) {
      context.commit('toggleSnackbar', {
        text: 'Error updating course.',
        color: 'error',
      });
      throw (e);
    } finally {
      context.commit('setIsUpdating', false);
    }
  },
  async validateWellbeing(context, courseData) {
    context.commit('setIsUpdating', true);
    try {
      context.commit('toggleSnackbar', {
        text: 'Redirecting...',
        color: 'success',
      });
      const res = await Vue.$api.playlist.validateWellbeingEmail(courseData);
      const phpUrl = dynamicPHPPath(window.location.hostname);
      window.open(phpUrl + res.data, '_self');
    } catch (e) {
      const message = _.get(e.response, 'data.message');
      context.commit('toggleSnackbar', {
        text: message,
        color: 'error',
      });
      context.commit('setIsUpdating', false);
    }
  },
};
